// extracted by mini-css-extract-plugin
export default {"CentralModal":"CentralModal_CentralModal__xHEpC","CentralModalOverlay":"CentralModal_CentralModalOverlay__PsCJs"};